import { render, staticRenderFns } from "./PopupImage.vue?vue&type=template&id=d99213c6&scoped=true&"
import script from "./PopupImage.vue?vue&type=script&lang=js&"
export * from "./PopupImage.vue?vue&type=script&lang=js&"
import style0 from "./PopupImage.vue?vue&type=style&index=0&id=d99213c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99213c6",
  null
  
)

export default component.exports